import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { translations } from "../../utils/constants";
import moment from "moment";
import { convertItalianToLocalTime } from "../../utils/helpers";


const WorkTimerPopup = ({
  open,
  onClose,
  entryTime,
  user,
  language,
  viewRecord,
  onBreak,
  breaks = [],
}) => {
  const [elapsed, setElapsed] = useState({ h: "00", m: "00", s: "00" });
  const [greeting, setGreeting] = useState("");
  const day = viewRecord?.work_day;
  const isToday = moment(day).isSame(moment(), "day");


  // console.log(viewRecord, 'viewRecord')

  // --- Utility to parse "HH:mm:ss" or ISO to Date ---
  const parseTime = (timeStr) => {
    if (!timeStr) return null;

    try {
      const localMoment = convertItalianToLocalTime(timeStr);
      return localMoment ? localMoment.toDate() : null;
    } catch (err) {
      console.error("❌ parseTime error:", err, timeStr);
      return null;
    }
  }


  // --- Total break seconds (only ended breaks) ---
  const calcEndedBreakSeconds = (breaksList) => {
    if (!Array.isArray(breaksList)) return 0;
    const today = new Date();
    const y = today.getFullYear(),
      m = today.getMonth(),
      d = today.getDate();
    let total = 0;


    breaksList.forEach((b) => {
      if (!b.start_time || !b.end_time) return;
      const [hs, ms, ss = 0] = b.start_time.split(":").map(Number);
      const [he, me, se = 0] = b.end_time.split(":").map(Number);
      const start = new Date(y, m, d, hs, ms, ss);
      const end = new Date(y, m, d, he, me, se);
      total += Math.max(0, (end - start) / 1000);
    });


    return total;
  };


  // useEffect(() => {
  //   if (!entryTime) return;
  //   const entryDate = parseTime(entryTime);
  //   if (!entryDate || isNaN(entryDate.getTime())) return;


  //   const updateElapsed = () => {
  //     const now = new Date();
  //     const endedBreakSeconds = calcEndedBreakSeconds(breaks);


  //     // If user currently on break → freeze at break start
  //     let endPoint = now;
  //     if (onBreak && breaks.length > 0) {
  //       const last = breaks[breaks.length - 1];
  //       if (last && !last.end_time && last.start_time)
  //         endPoint = parseTime(last.start_time);
  //     }


  //     const totalSeconds = Math.max(
  //       0,
  //       (endPoint - entryDate) / 1000 - endedBreakSeconds
  //     );


  //     const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  //     const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  //     const s = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
  //     setElapsed({ h, m, s });
  //   };


  //   updateElapsed();
  //   const interval = setInterval(updateElapsed, 1000);
  //   return () => clearInterval(interval);
  // }, [entryTime, breaks, onBreak]);




  useEffect(() => {
    if (!entryTime) return;


    const entryDate = parseTime(entryTime);
    if (!entryDate || isNaN(entryDate.getTime())) return;


    const updateElapsed = () => {
      // ✅ Stop timer if work session completed
      const hasCompleted =
        viewRecord?.status === 'completed' || !!viewRecord?.exit_time;
      if (hasCompleted) {
        const end = parseTime(viewRecord?.exit_time);
        if (end) {
          const endedBreakSeconds = calcEndedBreakSeconds(breaks);
          const totalSeconds = Math.max(
            0,
            (end - entryDate) / 1000 - endedBreakSeconds
          );


          const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
          const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
          const s = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
          setElapsed({ h, m, s });
        }
        return; // stop further updates
      }


      const now = new Date();
      const endedBreakSeconds = calcEndedBreakSeconds(breaks);
      let endPoint = now;


      if (viewRecord?.status === 'break' && breaks.length > 0) {
        const last = breaks[breaks.length - 1];
        if (last && !last.end_time && last.start_time)
          endPoint = parseTime(last.start_time);
      }

      // if (viewRecord?.status === "break") {
      //   if (breaks.length > 0) {
      //     const last = breaks[breaks.length - 1];
      //     if (last && !last.end_time && last.start_time) {
      //       endPoint = parseTime(last.start_time);
      //     }
      //   } else {
      //     // ⏸ If no breaks yet, stop counting further
      //     endPoint = entryDate;
      //   }
      // }
      const totalSeconds = Math.max(
        0,
        (endPoint - entryDate) / 1000 - endedBreakSeconds
      );


      const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
      const s = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
      setElapsed({ h, m, s });
    };


    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);
    return () => clearInterval(interval);
  }, [entryTime, breaks, viewRecord]);


  // --- Greeting ---
  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) setGreeting(`${translations[language].goodMorning} ☀️`);
    else if (hour < 18) setGreeting(`${translations[language].goodAfterNoon} 🌤️`);
    else setGreeting(`${translations[language].goodEvening} 🌙`);
  }, [language]);


  const displayName =
    viewRecord?.employee_name?.charAt(0).toUpperCase() + viewRecord?.employee_name?.slice(1) || "User";


  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      bodyStyle={{
        padding: "28px 32px",
        borderRadius: "24px",
        background: "#f9fafb",
      }}
      closable={true}
    >
      {isToday ?
        <div className="text-center">
          <h2 className="text-gray-800 text-lg font-semibold mb-5">
            {translations[language].activeWorkSession}
          </h2>


          <p style={{ color: "#374151", fontWeight: "600", fontSize: "15px", margin: 0 }}>
            {translations[language].hello} {displayName}, {greeting}
          </p>
          <p style={{ color: "#374151", fontWeight: "600", fontSize: "15px", marginBottom: "4px" }}>
            {translations[language].youHaveWorked}
          </p>


          {/* Timer Card */}
          <div
            style={{
              background: viewRecord?.status === 'break' ? "#9ca3af" : "red",
              borderRadius: "16px",
              padding: "20px 24px",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              color: "#fff",
              boxShadow: "0 6px 16px rgba(239,68,68,0.4)",
            }}
          >
            {[{ label: "Hours", value: elapsed.h },
            { label: "Minutes", value: elapsed.m },
            { label: "Seconds", value: elapsed.s }].map((t, i) => (
              <div key={i} style={{ textAlign: "center" }}>
                <div style={{ fontSize: "28px", fontWeight: "700" }}>{t.value}</div>
                <div
                  style={{
                    fontSize: "11px",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.9)",
                    marginTop: "2px",
                    letterSpacing: "1px",
                  }}
                >
                  {t.label}
                </div>
              </div>
            ))}
          </div>


          <div style={{ marginTop: "18px" }}>
            <p style={{ color: "#6b7280", fontSize: "13px" }}>
              {translations[language].workingSince}{" "}
              <b>
                {viewRecord?.work_day && entryTime
                  ? `${moment(viewRecord.work_day).format("DD-MM-YYYY")} ${convertItalianToLocalTime(
                    entryTime,
                    "HH:mm:ss"
                  ).format("HH:mm")}`
                  : "--"}
              </b>
            </p>


            {viewRecord?.status === 'break' && (
              <p
                style={{
                  marginTop: "6px",
                  color: "#ef4444",
                  fontSize: "13px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#ef4444",
                    borderRadius: "50%",
                    animation: "blink 1s infinite",
                  }}
                />
                {translations[language]?.currentlyOnBreak}
              </p>
            )}
          </div>


          <style>
            {`
           @keyframes blink {
             0%, 50%, 100% { opacity: 1; }
             25%, 75% { opacity: 0.3; }
           }
         `}
          </style>
        </div> :
        <div className="text-center">
          <h2 className="text-gray-800 text-lg font-semibold mb-5">
            {translations[language].activeWorkSession}
          </h2>


          <p style={{ color: "#374151", fontWeight: "600", fontSize: "15px", marginBottom: "4px" }}>
            {translations?.[language]?.yourWorkRecordOn} {moment(viewRecord?.work_day).format('DD-MM-YYYY')}
          </p>


          <div
            style={{
              background: "red",
              borderRadius: "16px",
              padding: "20px 24px",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              color: "#fff",
              boxShadow: "0 6px 16px rgba(239,68,68,0.4)",
            }}
          >{
              // viewRecord?.status === 'missed' ?
              // <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start' }}>
              //   <span>You Have Missed Checkout <br />Please Contact Admin</span>
              // </div>
              // :


              [{ label: translations[language]?.hour, value: elapsed.h },
              { label: translations[language]?.minutes, value: elapsed.m },
              { label: translations[language]?.seconds, value: elapsed.s }].map((t, i) => (
                <div key={i} style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "28px", fontWeight: "700" }}>{t.value}</div>
                  <div
                    style={{
                      fontSize: "11px",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,0.9)",
                      marginTop: "2px",
                      letterSpacing: "1px",
                    }}
                  >
                    {t.label}
                  </div>
                </div>
              ))}
          </div>


          {/* <div style={{ marginTop: "18px" }}>
           <p style={{ color: "#6b7280", fontSize: "13px" }}>
             {translations[language].workingSince}{" "}
             <b>
               {entryTime
                 ? `${new Date().toLocaleDateString()} ${entryTime.replace(
                   /^(\d{2}:\d{2}).*$/,
                   "$1"
                 )}`
                 : "--"}
             </b>
           </p> */}




          {/* </div> */}
        </div>}
    </Modal>
  );
};


export default WorkTimerPopup;

